import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import {
  lockSsoRouteProviders,
  ssoRouteDependentBranches,
} from "../ssoRouteDependencies";
import { mutator } from "./mutator";

export const deleteSSOProvider = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {
    provider: { kind: "ssoProvider", from: "id" },
  },
  permissions: [
    { permission: "tenant:sso_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { provider } }) => {
    await lockSsoRouteProviders(tx, ctx.tenantId);
    const current = await tx.run(
      zql.ssoProvider.where("id", provider.id).one()
    );
    if (!current) return;
    const dependencies = await tx.run(
      ssoRouteDependentBranches(
        ctx.tenantId,
        current.providerId,
        current.isPrimary ?? false
      )
        .where("name", "main")
        .limit(1)
    );
    if (dependencies.length > 0) {
      throw userFacingError(
        "Published SSO routes depend on this provider. Repoint or disable those routes and republish their workflows before deleting the provider."
      );
    }
    await tx.mutate.ssoProvider.delete({ id: current.id });
  },
});
